import Vue from 'vue';

import i18n from '@/i18n';
import {
  getAuthorizationCode,
  getToken,
  revokeToken,
  generateCodeVerifier,
  refreshToken,
} from '@/services/auth';

export const state = {
  code_verifier: null,
  credentials: {},
  user: {},
};

export const mutations = {
  setCodeVerifier(state, codeVerifier) {
    state.code_verifier = codeVerifier;
  },

  setCredentials(state, credentials) {
    state.credentials = credentials;
  },

  setUser(state, user) {
    state.user = user;
  },

  reset(state) {
    state.credentials = {};
    state.user = {};
  },
};

export const actions = {
  getAuthorizationCodeAndRedirect({ commit }) {
    const codeVerifier = generateCodeVerifier();

    return getAuthorizationCode(codeVerifier).then(response => {
      commit('setCodeVerifier', codeVerifier);

      // Axios doesn't follow 302 redirections automatically so we have to do it manually
      window.location.href = response.request.responseURL;
    });
  },

  login({ state, commit, dispatch }, authorizationCode) {
    return getToken(state.code_verifier, authorizationCode)
      .then(response => {
        commit('setCredentials', response.data);
        commit('setCodeVerifier', null);

        dispatch('users/getUser', 'me', { root: true }).then(response => {
          commit('setUser', response.data);
        });
      })
      .catch(() => {
        dispatch('getAuthorizationCodeAndRedirect');
      });
  },

  refreshTokenOrLogout({ commit, state }) {
    return refreshToken(state.credentials.refresh_token).then(
      response => {
        commit('setCredentials', response.data);
      },
      () => {
        commit('reset');
        // Notifications toaster component is different when user is logged out
        // Let’s wait for the new one to be rendered before triggering the notification
        Vue.nextTick(() => {
          Vue.notify({
            type: 'error',
            title: i18n.t('authentication.label'),
            text: i18n.t('authentication.expired'),
            duration: 5000,
          });
        });
      }
    );
  },

  logout({ commit, state }) {
    const token = state.credentials.access_token;
    commit('reset');
    return revokeToken(token);
  },
};

export const getters = {
  currentUser: (state, getters, rootState) => {
    return rootState.users.index[state.user.username];
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
